import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
import { toRefs } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuButton',
    props: {
        btnSize: { default: 'size-m' },
        items: { default: () => [] }
    },
    setup(__props) {
        const router = useRouter();
        const setupProps = __props;
        const { items, } = toRefs(setupProps);
        /**
         * 메뉴 클릭 핸들러
         */
        const handleClickMenuBtn = ({ to, action }) => {
            if (to) {
                router.push({
                    name: to,
                });
                return;
            }
            if (action) {
                action();
            }
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            return (_openBlock(), _createBlock(_component_v_menu, {
                "offset-y": "",
                left: "",
                "content-props": {
                    class: 'brg-select-option',
                }
            }, {
                activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                        class: ["cy-menu-btn brg-btn info outlined", _ctx.btnSize]
                    }), {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "menuName", {}, () => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" mdi-cog-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                }),
                                _createCommentVNode(" [메뉴이름] ")
                            ])
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: item.title,
                                    onClick: ($event) => (handleClickMenuBtn(item))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 3 /* FORWARDED */
            }));
        };
    }
});
